// ── Overlay Navigation ──
function showOverlay(id) {
  document.querySelectorAll('.page-overlay').forEach(function(o){ o.classList.remove('visible'); });
  var el = document.getElementById(id);
  if (el) { el.classList.add('visible'); window.scrollTo(0,0); el.scrollTop = 0; }
}
function hideOverlay(id) {
  var el = document.getElementById(id);
  if (el) el.classList.remove('visible');
}
function showMain(e) {
  if (e) e.preventDefault();
  document.querySelectorAll('.page-overlay').forEach(function(o){ o.classList.remove('visible'); });
}

// ── Step Accordion ──
function toggleStep(el) { el.classList.toggle('active'); }

// ── FAQ Card Accordion ──
function toggleFaqCard(card) {
  var isOpen = card.classList.contains('open');
  // Close all in the same list
  var list = card.closest('.faq-list');
  if (list) {
    list.querySelectorAll('.faq-card').forEach(function(c){
      c.classList.remove('open');
      c.querySelector('.faq-chevron').textContent = '∨';
    });
  }
  if (!isOpen) {
    card.classList.add('open');
    card.querySelector('.faq-chevron').textContent = '∧';
  }
}

document.addEventListener('DOMContentLoaded', function () {
  // ── Mobile Nav ──
  var hamburger = document.getElementById('navHamburger');
  var mobileMenu = document.getElementById('mobileMenu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function(){ mobileMenu.classList.toggle('open'); });
  }
  window.closeMobile = function() { if (mobileMenu) mobileMenu.classList.remove('open'); };

  // ── Student Modal ──
  var modalBg   = document.getElementById('studentModalBg');
  var closeBtn  = document.getElementById('closeStudentModal');
  var verifyBtn = document.getElementById('verifyStudentEmail');
  var copyBtn   = document.getElementById('copyStudentCode');

  if (closeBtn) closeBtn.addEventListener('click', function(){ modalBg.classList.remove('open'); });
  if (modalBg)  modalBg.addEventListener('click', function(e){ if (e.target===modalBg) modalBg.classList.remove('open'); });

  if (verifyBtn) {
    verifyBtn.addEventListener('click', function(){
      var email  = document.getElementById('studentEmail');
      var error  = document.getElementById('eduError');
      var code   = document.getElementById('sm-code-box');
      var form   = document.getElementById('sm-form-area');
      if (!email.value.endsWith('.edu')) { error.style.display='block'; return; }
      error.style.display='none'; code.classList.add('visible'); form.style.display='none';
    });
  }
  if (copyBtn) {
    copyBtn.addEventListener('click', function(){
      navigator.clipboard.writeText('G34YQBB726Q6').then(function(){
        copyBtn.textContent='Copied!';
        setTimeout(function(){ copyBtn.textContent='Copy Code'; }, 2000);
      });
    });
  }
  window.openStudentModal = function(){ modalBg.classList.add('open'); };

  // ── Footer Email ──
  window.submitFooterEmail = function(){
    var input = document.getElementById('footerEmail');
    if (input && input.value.includes('@')) {
      var btn = document.querySelector('.footer-email-btn');
      if (btn){ btn.textContent='✓'; btn.style.color='#4ade80'; }
      input.value=''; input.placeholder="Thanks! You're in.";
    }
  };
});

// ── Bundle Selector ──
function selectBundle(el) {
  document.querySelectorAll('.bundle-option').forEach(function(b){ b.classList.remove('selected'); });
  el.classList.add('selected');
  var btn   = document.getElementById('orderBtn');
  var price = document.getElementById('selectedPrice');
  if (btn   && el.dataset.url)   btn.href = el.dataset.url;
  if (price && el.dataset.price) price.textContent = el.dataset.price;
}

// ── Product Overlay ──
function switchOverlayImg(thumb, src) {
  var main = document.getElementById('overlayMainImg');
  if (main) main.src = src || thumb.src;
  document.querySelectorAll('.prod-overlay-thumb').forEach(function(t){ t.classList.remove('active'); });
  thumb.classList.add('active');
}

function selectOverlayBundle(el) {
  document.querySelectorAll('.prod-bundle').forEach(function(b){ b.classList.remove('selected'); });
  el.classList.add('selected');
  var btn = document.getElementById('overlayOrderBtn');
  var price = document.getElementById('overlaySelectedPrice');
  if (btn && el.dataset.url) btn.href = el.dataset.url;
  if (price && el.dataset.price) price.textContent = el.dataset.price;
}
